import {
  BOOST,
  INDEED,
  JOVEO,
  REACH,
  SPRING,
  TALROO,
  ZIPRECRUITER,
} from '@/types/channels';

const getChannelName = (channelSlug: string) => {
  switch (channelSlug) {
    case INDEED:
      return 'Indeed';
    case BOOST:
      return 'Boost';
    case SPRING:
      return 'Spring';
    case TALROO:
      return 'Talroo';
    case ZIPRECRUITER:
      return 'ZipRecruiter';
    case JOVEO:
      return 'Joveo';
    case REACH:
      return 'Reach';
    default:
      return channelSlug;
  }
};

export { getChannelName };
